import { ApiRequest, BaseResource, postItem, patchItem } from "utils/ApiUtils"
import buildQuery from 'odata-query'
import ODataUtil from './ODataUtil'

const samples_endpoint = "/BaseSamples"

class Sample extends BaseResource {
  constructor(args, attr = Sample.attributes) {
    super(args, attr)
  }

  static columns = [
    { title: "Sample ID", field: "SampleCd" },
    { title: "Date", field: "SampleDate", type: "date", defaultSort: 'desc' },
    { title: "Inspection #", field: "InspectionNumber_Inspection" },
    { title: "Inspection Status", field: "Description_InspectionStatus" },
    { title: "Inspector", field: "Name_SystemUser" },
    { title: "Material Desc - Spec", field: "MaterialDesc_FieldMaterial" },
    { title: "Material Supplier", field: "Supplier_FieldMaterial" },
    { title: "Subcategory", field: "Category_FieldMaterial" },
    { title: "SpecItem", field: "SpecItem_FieldMaterial" },
    { title: "Base Sample Id", field: "BaseSampleId", type: "guid", hiddenByColumnsButton: true, hidden: true },
    { title: "Lab Results", field: "Status", sorting: false, filter: false },
    { title: "Attachments", field: "Attach", sorting: false,  filter: false },
  ]

  static SampleByIDColumns = [
    { title: "Sample Type", field: "Description_AnalysisType", hidden: true },
    { title: "Quantity", field: "Quantity", hidden: true },
    { title: "Sample Freq", field: "SampleFreqQty", hidden: true },
    { title: "Ticket", field: "Ticket", hidden: true },
    { title: "Station", field: "Station", hidden: true },
    { title: "Station", field: "StationPartA", hidden: true },
    { title: "Station", field: "StationPartB", hidden: true },
    { title: "OffsetDistance", field: "OffsetDistance", hidden: true },
    { title: "Elevation", field: "Elevation", hidden: true },
    { title: "LocationDetails", field: "LocationDetails", hidden: true },
    { title: "LocRangeBegin", field: "LocRangeBegin", hidden: true },
    { title: "LocRangeEnd", field: "LocRangeEnd", hidden: true },
    { title: "Comments", field: "Comments", hidden: true },
    { title: "Projected Date", field: "DateDeliveredProj", type: "date", hidden: true },
    { title: "baseSampleId", field: "BaseSampleId", hidden: true, type: "guid" },
    { title: "Sample ID", field: "SampleCd" },
    { title: "Date", field: "SampleDate", type: "date" },
    { title: "Inspection #", field: "InspectionNumber_Inspection" },
    { title: "Inspector", field: "SystemUser_Name" },
    { title: "Material Desc - Spec", field: "MaterialDesc_FieldMaterial" },
    { title: "Material Supplier", field: "Supplier_FieldMaterial" },
    { title: "PassFail", field: "PassFail", hidden: true },
    { title: "Concrete", field: "Concrete", hidden: true },
    { title: "Category_FieldMaterial", field: "Category_FieldMaterial", hidden: true },
    { title: "DeliveryLog", field: "SampleDeliveryLogs", hidden: true },
    { title: "Status", field: "Status", sorting: false },
    { title: "Attachments", field: "Attach", sorting: false, filter: false },
  ]
  static attributes = Sample.columns.map(r => r.field)
  static attributesByID = Sample.SampleByIDColumns.map(r => r.field)


  static expand = [
    { "Ihwi": { "expand": [{ "Inspection": { "select": ["InspectionNumber"], "expand": [{ "Rassignment": { "expand": [{ "SystemUser": { select: ["Name"] } }] } }] } }] } },
      { "MaterialSamples": { "expand": [{ "FieldMaterial": { select: ["MaterialDesc", "Supplier", "Category", "MaterialSub","SpecItem"] } }] } },
    { "ConcreteGroutSamples": { "expand": ["sampleSize", "cylinders"] } },
    { "SampleDeliveryLogs": {} },
    { "LabResults": { expand: ["PassFail", "LabSampleForm"] } },
    { "Ihwi": { "expand": [{ "Inspection": { "select": ["InspectionNumber"] } }] } },
    { "Ihwi": { expand: { Inspection: {expand: { InspectionStatus: { select: ["Description"]}}}}}},
    { "AnalysisType": { select: ["Description"] } }
  ]
}

function convert_sample_to_table_schema({ "value": items, "@odata.count": count }, status) {

  let filter = items
  const data = filter.map(r => {
    const sample = new Sample(r)
    sample.Name_SystemUser = r.Ihwi.Inspection.Rassignment && r.Ihwi.Inspection.Rassignment.SystemUser.Name;
    sample.InspectionNumber_Inspection = r.Ihwi.Inspection && r.Ihwi.Inspection.InspectionNumber;
    sample.MaterialDesc_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.MaterialDesc;
      sample.Supplier_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.Supplier;
      sample.Category_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.MaterialSub;
      sample.SpecItem_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.SpecItem;
    sample.Description_InspectionStatus = r.Ihwi.Inspection.InspectionStatus.Description;
    sample.Status = r.LabResults && r.LabResults.length > 0 ? r.LabResults.filter(pf => pf.PassFail.Description !== 'N/A').length + ' of ' + r.LabResults.length : '0 of 0'
    sample.Attach = r.LabResults && r.LabResults.length > 0 ? r.LabResults.filter(att => att.FileUploadUid !== null && att.FileUploadUid !== "") : []
    return sample
  });
  return {
    data, count
  }
}

function convert_sampleByID_to_table_schema({ "value": items, "@odata.count": count }) {
  const data = items.map(r => {
    const sample = new Sample(r, Sample.attributesByID)
    sample.Name_SystemUser = r.Ihwi.Inspection.Rassignment && r.Ihwi.Inspection.Rassignment.SystemUser.Name
    sample.InspectionNumber_Inspection = r.Ihwi.Inspection && r.Ihwi.Inspection.InspectionNumber
    sample.MaterialDesc_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.MaterialDesc
      sample.Supplier_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.Supplier
      sample.Category_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.Category;
      sample.SpecItem_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.SpecItem;
    sample.Description_AnalysisType = r.AnalysisType && r.AnalysisType.Description
    sample.Concrete = r.ConcreteGroutSamples && r.ConcreteGroutSamples
    sample.LabResults = r.LabResults && r.LabResults
    sample.SampleDeliveryLogs = r.SampleDeliveryLogs && r.SampleDeliveryLogs
    sample.Description_InspectionStatus = r.Ihwi.Inspection.InspectionStatus.Description;
    sample.Category_FieldMaterial = r.MaterialSamples.FieldMaterial && r.MaterialSamples.FieldMaterial.Category;
    if(r.StationPartA) {
      sample.Station = `${r.StationPartA} + ${r.StationPartB ? r.StationPartB : "00"}`
    } else {
      sample.Station = undefined;
    }
    sample.Status = r.LabResults && r.LabResults.length > 0 ? r.LabResults.filter(pf => pf.PassFail.Description !== 'N/A').length + ' of ' + r.LabResults.length : '0 of 0'
    sample.Attach = r.LabResults && r.LabResults.length > 0 ? r.LabResults.filter(att => att.FileUploadUid !== null && att.FileUploadUid !== "") : [];
    return sample
  }
  )
  return {
    data, count
  }
}

async function getSamples(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, Sample.expand, orderByInfo, orderByDirection, filters
  );
  let filter = {};
  const isDefaults = filters.find(r => r.defaults);

  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if (defaults.projectId) filter["Ihwi/Inspection/Rassignment/ProjectId"] = { eq: { type: 'guid', value: defaults.projectId } };
    if (defaults.inspectionNumber) filter["Ihwi/Inspection/InspectionNumber"] = defaults.inspectionNumber;
  };

  if (search.Status) {
    if (search.Status === "active" || search.Status === "complete") {
      filter = {
        ...filter,
        SampleDeliveryLogs: {
          any: search.Status === "complete" ? { "PassFail": true } : { or: [{ "PassFail": false }, { "PassFail": null }]}
        }
      }
    } else {
      filter = {
        ...filter,
        and: {
          not: {
            SampleDeliveryLogs: {
            any: []
          }}
        }
      }
    };
  };

  const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
  let params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(samples_endpoint, params);
  return convert_sample_to_table_schema(data, search.Status)
}

async function getSamplesByID(page, per_page, orderByInfo, orderByDirection, search, filters = []) {
  const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, Sample.expand, orderByInfo, orderByDirection, filters
  );
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);
  console.log(isDefaults)

  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if (defaults.projectId) filter["Ihwi/Inspection/Rassignment/ProjectId"] = { eq: { type: 'guid', value: defaults.projectId } };
  };
  filter['SampleCd'] = { eq: search.SAMPLE_CD };
  if(search.projectID)
    filter["Ihwi/Inspection/Rassignment/ProjectId"] = { eq: { type: 'guid', value: search.projectID } };
  const allFilters = mappedFilter.reduce((a, b) => ({ ...a, ...b }), filter);
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(samples_endpoint, params)
  return convert_sampleByID_to_table_schema(data)
}

async function addDeliveryLog(data) {
  const resourcePath = `${samples_endpoint}/Log/Add`
  const result = await postItem(resourcePath, undefined, data, false, true)
  return result
}

async function updateDeliveryLog(data) {
  const resourcePath = `${samples_endpoint}/Log/Update`;
  const params = `?deliverylogid=${data.DeliveryLogId}`
  const result = await patchItem(resourcePath, params, data)
  return result
}

export { Sample, getSamples, getSamplesByID, addDeliveryLog, updateDeliveryLog }